import { render, staticRenderFns } from "./InputTwoLists.vue?vue&type=template&id=9c918a34"
import script from "./InputTwoLists.vue?vue&type=script&lang=js"
export * from "./InputTwoLists.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports